import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import config from 'config/env.config';

const app = initializeApp(config.firebase);
const analytics = getAnalytics(app);

export const auth = getAuth();
